import { createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { RestApiService } from '@/services'

import { ApplicationState } from '@/state/root.models'
import { RoleType } from '@/enums/role.enum'
import { persistor } from '@/state'

import {
  setLoadingFullAction,
  setSidebarStatusAction,
} from '@/state/ui/global/slices/index.slices'
import { WalletActions } from '@/state/wallets/slices/index.slices'
import ActionTypes from '../constants'

import {
  resetAuthLogoutAction,
  resetLoggedInUserStateAction,
  setSidebarIdsAction,
  setUserSessionAction,
} from '../slices/index.slices'

const restApiService: RestApiService = Container.get(RestApiService)

const logoutThunk = createAsyncThunk(
  ActionTypes.LOGOUT,
  async (_, thunkAPI) => {
    // eslint-disable-next-line
    try {
      const { auth } = thunkAPI.getState() as ApplicationState

      restApiService.requestParams = {
        method: 'POST',
        endpoint: 'auth/logout',
        body: {
          user: {
            id: auth.userSession.id,
            username: auth.userSession.username,
          },
        },
      }

      thunkAPI.dispatch(setLoadingFullAction(true))

      restApiService.sendAuthData(auth.token || '')

      thunkAPI.dispatch(setLoadingFullAction(false))

      thunkAPI.dispatch(resetAuthLogoutAction())
      thunkAPI.dispatch(resetLoggedInUserStateAction())
      thunkAPI.dispatch(
        setUserSessionAction({
          id: '',
          username: '',
          role: RoleType.SUPER_ADMIN,
          iat: 0,
          exp: 0,
        }),
      )
      thunkAPI.dispatch(setSidebarIdsAction([]))
      thunkAPI.dispatch(setSidebarStatusAction(false))
      thunkAPI.dispatch(WalletActions.resetFreePlaysCalculated())

      localStorage.clear()
      sessionStorage.clear()
      persistor.purge()
      persistor.flush()

      // TODO In the next implementations check this redirection
      // thunkAPI.dispatch(push(routes.auth.LOGIN))
    } catch (error) {
      throw error
    }
  },
)

export default logoutThunk
